export function selectResourceResult(stateSource, root, vars) {
    // If `getData()` or `getRejection()` are called while there's no
    // subscription, then they need to request the data and throw
    // a promise to the result -- this function facilitates that.
    var waitForValue = stateSource.filter(function (result) { return result.primed; }).getValue;
    return stateSource.map(function (result) { return ({
        abandoned: result.primed && !result.hasData && !result.hasRejection,
        get data() {
            if (!result.primed) {
                throw waitForValue();
            }
            if (!result.hasData) {
                throw new Error("Resource Error: no data is available. To prevent this error, ensure " +
                    "that the \"hasData\" property is true before accessing \"data\".");
            }
            return result.data;
        },
        get rejection() {
            if (!result.primed) {
                throw waitForValue();
            }
            if (!result.hasRejection) {
                throw new Error("Resource Error: no rejection is available. To prevent this error, " +
                    "ensure that the \"hasRejection\" property is true before accessing " +
                    "\"rejection\".");
            }
            return result.rejection;
        },
        hasData: !!result.hasData,
        hasRejection: !!result.hasRejection,
        id: root.id,
        invalidated: result.invalidated,
        pending: result.pending,
        primed: result.primed,
        bucket: root.bucket,
        vars: vars,
    }); });
}
//# sourceMappingURL=selectResourceResult.js.map